import { useError } from "../../Contexts/ErrorContext";
import { useState } from "react";

const useApi = () => {
  const { showError, error } = useError();
  const [isLoading, setIsLoading] = useState(false);

  const callApi = async (apiCall, onSuccess, onFail) => {
    setIsLoading(true);
    try {
      const response = await apiCall();
      if (onSuccess) await onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.log(err);
      const message = err.response?.data?.message || "Wystąpił błąd.";
      if (onFail) await onFail();
      showError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return { callApi, isLoading, error };
};

export default useApi;
